import React from 'react'
import { TextLegacy } from '@/components/common'
import Table from '@/components/common/table/table'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'
import LinkButtonGotoPolicyPage from '@/components/domains/policy/LinkButtonGotoPolicyPage'
import { ENV_CONFIG } from '@/constants/env/config'
import { FITPET } from '@/constants/legacy/constData'
import ROUTES from '@/constants/legacy/constRoutes'

const PolicyLocation = ({
  fontSize = { xs: 12, md: 14 },
  paddingTop = 40,
}: {
  fontSize?: FontResponsiveSizeType
  paddingTop?: number
}) => {
  const columnsService = [
    {
      title: '서비스명',
      dataIndex: 'name',
      key: 'name',
      width: '12%',
      render: (value: React.ReactNode, _record: any, index: number) => {
        const rowSpan = index === 0 ? 2 : index && index < 2 ? 0 : 1
        return { children: value, props: { rowSpan } }
      },
    },
    {
      title: '서비스 내용',
      dataIndex: 'description',
      key: 'description',
      render: (value: React.ReactNode) => {
        return { children: value }
      },
    },
    {
      title: <span style={{ textDecoration: 'underline' }}>개인위치정보 보유기간</span>,
      dataIndex: 'period',
      key: 'period',
      render: (value: React.ReactNode, _record: any, index: number) => {
        const rowSpan = index === 0 ? 3 : 0
        return { children: value, props: { rowSpan } }
      },
    },
  ]
  const dataSourceService = [
    {
      key: 1,
      name: <span style={{ textDecoration: 'underline' }}>병원</span>,
      description:
        '①	위치정보를 활용한 병원 찾기 서비스: 정보 검색을 요청하거나 개인위치정보주체 또는 이동성 있는 기기의 위치정보를 제공 시 본 위치정보를 이용한 검색결과 및 주변결과(주변 동물병원 등)을 제시합니다.',
      period: <span style={{ textDecoration: 'underline' }}>서비스의 목적 달성 후 지체 없이 파기</span>,
    },
    {
      key: 2,
      name: <span style={{ textDecoration: 'underline' }}>병원</span>,
      description:
        '②	병원 안내 등 생활편의 서비스 제공: 이용자가 설정한 위치에서부터 선택한 동물병원까지의 교통정보와 길 안내 등 최적의 경로를 제공합니다.',
    },
    {
      key: 3,
      name: <span style={{ textDecoration: 'underline' }}>플레이</span>,
      description: (
        <span style={{ textDecoration: 'underline' }}>
          개인위치정보주체 또는 이동성 있는 기기의 위치 정보를 제공 시 본 위치정보를 이용하여 실제 이동한 거리의 측정 및
          걸음수를 제공합니다.
        </span>
      ),
    },
  ]

  return (
    <div style={{ padding: 10, paddingTop: paddingTop }}>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        제 1 조 (목적) <br />
        본 약관은 주식회사 핏펫(이하 “회사”라고 합니다.)이 회사에서 운영하는 핏펫몰(https://fitpetmall.com) 및 핏펫
        앱(이하 통칭하여 “핏펫몰”)을 통하여 제공하는 위치기반 서비스(이하 “서비스”라고 합니다)를 서비스 이용자(본 약관에
        동의한 자를 말하며, 핏펫몰 회원과 비회원이 모두 포함됩니다. 이하 “이용자”라고 합니다)가 이용함에 있어 회사와
        이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
        <br />
        <br />
        제 2 조 (이용약관의 효력 및 변경)
        <br />
        ① 본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라
        서비스의 이용자로 등록함으로써 효력이 발생합니다.
        <br />
        ② 이용자가 온라인에서 본 약관의 &quot;동의하기&quot; 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를
        충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.
        <br />
        ③ 회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률,
        소비자기본법 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
        <br />
        ④ 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께
        그 적용일자 10일 전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 이용자에게 불리한 경우에는 그
        적용일자 30일 전부터 적용일 이후 상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 이용자에게 전자적
        형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여 고지합니다. <br />
        ⑤ 회사가 전항에 따라 이용자에게 통지하면서 공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지 거부의사를
        표시하지 아니하면 이용약관에 승인한 것으로 봅니다. 이용자가 개정약관에 동의하지 않을 경우 이용자는 이용계약을
        해지할 수 있습니다.
        <br />
        <br />
        제 3 조 (관계법령의 적용) <br />
        본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는
        상관례에 따릅니다.
        <br />
        <br />
        제 4 조 (서비스의 내용) <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ① 회사가 제공하는 서비스 및 개인위치정보의 보유목적과 기간은 아래와 같습니다.
      </TextLegacy>
      <Table data={dataSourceService} columns={columnsService} style={{ paddingBottom: 10 }} />
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ② 회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 개인위치정보 수집·이용·제공사실
        확인자료를 자동으로 기록·보존하며, 해당 자료는 6개월간 보관합니다.
        <br />
        ③ 회사는 개인위치정보의 이용 또는 제공 목적을 달성한 때에는 전항의 개인위치정보 수집·이 용·제공사실 확인자료를
        제외한 개인위치정보를 즉시 파기합니다. 다만 다른 법률에 따라 보유 하여야 하거나 이용자가 개인위치정보의 보유에
        별도로 동의한 경우 이용자가 동의한 때로부터 최대 1년간 이를 보유할 수 있습니다.
        <br />
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        제 5 조 (서비스 이용요금) <br />
        ① 회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을
        지불하여야 사용 가능합니다.
        <br />
        ② 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에
        합산하여 청구할 수 있습니다.
        <br />
        ③ 유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.
        <br />
        ④ 이용자의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될
        수 있습니다.
        <br />
        ⑤ 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.
        <br />
        ⑥ MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에 따릅니다.
        <br />
        <br />
        제 6 조 (서비스내용변경 통지 등)
        <br />
        ① 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 이용자의 등록된 전자우편 주소로 이메일을 통하여 서비스
        내용의 변경 사항 또는 종료를 통지할 수 있습니다.
        <br />
        ② 제1항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지사항을 통하여
        이용자들에게 통지할 수 있습니다.
        <br />
        <br />
        제 7 조 (서비스이용의 제한 및 중지)
        <br />
        ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 이용자의 서비스 이용을 제한하거나 중지시킬 수
        있습니다.
        <br />
        1. 이용자가 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우
        <br />
        2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우
        <br />
        3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우
        <br />
        4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때<br />
        5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우
        <br />② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을&nbsp;
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        서비스 홈페이지에 게시하고 이용자에게 전자적 형태(전자우편, SMS 등)로 개별 통지하여야 합니다. 단 회사가 위 게시
        및 통지를 할 수 없는 부득이한 사유가 있는 경우 사후에 게시 및 통지할 수 있습니다.
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        <br />
        <br />
        제 8 조 (개인위치정보의 이용 또는 제공)
        <br />
        ① 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의
        동의를 얻어야 합니다.
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ② 회사는 개인위치정보를 이용자가 지정하는 제3자에게 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 회원에게
        고지하고 동의를 받습니다.
        <br />
        ③ 전항에 따라 개인위치정보를 이용자가 지정하는 제3자에게 제공하는 경우에는 개인위치정 보를 수집한 해당 통신
        단말장치 또는 전자우편주소 등으로 매회 회원에게 제공받는 자, 제공 일시 및 제공목적(이하 “정보제공내역”이라
        합니다)을 즉시 통보합니다. 단, 아래 각 호에 해당 하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치 또는
        전자우편주소 등으로 통보합니다.
        <br />
        1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우
        <br />
        2. 이용자가 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리
        요청한 경우
        <br />
        ④ 전항에도 불구하고 이용자는 위치정보법 시행령 제24조에 따라 정보제공내역을 30일마다 모아서 통보받는 방법을
        선택할 수 있으며, 이용자가 고객센터 또는 홈페이지를 통하여 요청할 경우 전항에 따른 즉시 통보 방법으로 변경할 수
        있습니다.
        <br />⑤ 이용자가 제1항, 제2항, 제4항에 따른 동의를 하는 경우 이용/제공 목적, 제공받는 자의 범 위 및
        위치기반서비스 이용약관 내용 중 일부와 이용자의 개인위치정보에 대한 제3자 제공의 통보방법에 대하여 동의를 유보할
        수 있습니다. +
      </TextLegacy>
      <br />
      <br />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        제 9 조 (개인위치정보주체의 권리)
        <br />
        ① 이용자는 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한
        동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 철회한 부분에 관하여 수집한 개인위치정보 및 위치정보
        이용, 제공사실 확인자료를 파기합니다.
        <br />
        ② 이용자는 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는
        이를 거절할 수 없고 이를 위한 기술적 수단을 갖추고 있습니다.
        <br />
        ③ 이용자는 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는
        경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 이용자의 요구를 거절할 수 없습니다.
        <br />
        1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료
        <br />
        2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된
        이유 및 내용
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ④ 이용자는 회사의 고객센터(1:1 문의 서비스)를 통하여 제1항 내지 제3항의 권리행사를 요구할 수 있습니다.
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        <br />
        <br />
        제 10 조 (법정 대리인의 권리)
        <br />
        ① 회사는 14세 미만의 이용자에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에
        대한 동의를 당해 이용자와 당해 이용자의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에
        의한 이용자의 권리를 모두 가집니다.
        <br />
        ② 회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용, 제공사실 확인자료를 이용약관에 명시 또는 고지한
        범위를 넘어 이용하거나 제3자에게 제공하고자 하는 경우에는 14세 미만의 아동과 그 법정대리인의 동의를 받아야
        합니다. 단, 아래의 경우는 제외합니다.
        <br />
        1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우
        <br />
        2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ③ 회사는 다음 각 호의 어느 하나에 해당하는 방법으로 법정대리인이 동의했는지 확인합니다.
        <br />
        1. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 위치정보 사업자등이 그 동의
        표시를 확인했음을 법정대리인의 휴대전화 문자메시지로 알리는 방법
        <br />
        2. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리 인의 신용카드ᆞ직불카드
        등의 카드정보를 제공받는 방법
        <br />
        3. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리 인의 휴대전화 본인인증
        등을 통해 본인 여부를 확인하는 방법
        <br />
        4. 동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나, 우편 또는 팩스를 통하여 전달하 고 법정대리인이 동의
        내용에 대하여 서명날인 후 제출하도록 하는 방법
        <br />
        5. 동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우 편을 전송받는 방법
        <br />
        6. 전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나 인터넷주소 등 동의 내용 을 확인할 수 있는
        방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법
        <br />
        7. 그 밖에 제1호부터 제6호까지의 규정에 따른 방법에 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의
        의사표시를 확인하는 방법
        <br />
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        제 11 조 (8세 이하의 아동 등의 보호의무자의 권리) <br />
        ① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명
        또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
        <br />
        1. 8세 이하의 아동
        <br />
        2. 피성년후견인
        <br />
        3. 장애인복지법 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용 촉진 및 직업재활법 제2조
        제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법&nbsp;
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        제 32조의&nbsp;
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        규정에 의하여 장애인등록을 한 자에 한한다)
        <br />
        ② 전항의 규정에 따른 8세 이하 아동 등의 보호의무자는 해당 아동을 사실상 보호하는 자로서 다음 각 호에 해당하는
        자를 말합니다.
        <br />
        1. 8세 이하의 아동의 법정대리인 또는 보호시설에 있는 미성년자의 후견 직무에 관한 법률 제3조의 규정에 따른 후견인
        <br />
        2. 피성년후견인의 법정대리인
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        3. 본 조 제1항 제3호의 자의 법정대리인 또는 장애인복지법 제58조 제1항 제1호의 규정에 따른 장애인거주시설(국가
        또는 지방자치단체가 설치·운영하는 시설에 한합니다)의 장, 「정신건강증진 및 정신질환자 복지서비스 지원에 관한
        법률」 제22조에 따른 정신요양시설의 장 및 같은 법 제26조에 따른 정신재활시설(국가 또는 지방자치단체가
        설치ㆍ운영하는 시설로 한정한다)의 장<br />
        ③ 제1항에 따른 동의를 하고자 하는 8세 이하 아동 등의 보호의무자는 각 호의 사항을 기재하여 기명날인 또는 서면한
        서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
        <br />
        1. 8세 이하의 아동등의 성명, 주소 및 생년월일
        <br />
        2. 보호의무자의 성명, 주소 및 연락처
        <br />
        3. 개인위치정보 수집, 이용 또는 제공의 목적이 8세 이하의 아동등의 생명 또는 신체의 보호에 한정된다는 사실
        <br />
        4. 동의의 연월일
        <br />
        ④ 보호의무자는 8세 이하 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 제9조에 의한 이용자의 권리 전부를
        행사할 수 있습니다.
        <br />
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        제 12 조 (위치정보관리책임자의 지정)
        <br />
        ① 회사는 위치정보를 적절히 관리․보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수
        있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다. <br />
        ② 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.
        <br />
        <br />
        제 13 조 (손해배상) <br />
        ① 회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 이용자에게 손해가
        발생한 경우 이용자는 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지
        못하는 경우 책임을 면할 수 없습니다.
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ② 이용자는 관계 법령, 이 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을
        준수하여야 하며 기타 회사의 업무에 방해되는 행위를 해서는 안 됩니다.
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        <br />
        <br />
        제 14 조 (면책) <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 이용자에게 발생한 손해에 대해서는 책임을
        부담하지 않습니다. <br />
        1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우
        <br />
        2. 이용자의 귀책사유로 서비스 이용에 장애가 있는 경우
        <br />
        3. 제1호 내지 제2호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        <br />
        <br />제 15 조&nbsp;
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        (준거법 및 재판관할) <br />
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        ① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.
        <br />
        ② 본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        ③ 이용자 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를
        관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의
        경우에는 민사소송법상의 관할법원에 제기합니다.
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        <br />
        <br />
        제 16 조 (분쟁의 조정 및 기타) <br />
        ① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는
        위치정보의 보호 및 이용 등에 관한 법률 제28조의 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.
        <br />
        ② 회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는
        경우에는 개인정보보호법 제43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.
        <br />
        <br />
        제 17 조 (회사의 연락처) <br />
        회사의 상호 및 주소 등은 다음과 같습니다.
        <br />
        1. 상 호: 주식회사 핏펫
        <br />
        2. 대 표 자: 고정욱
        <br />
        {`3. 주 소: ${FITPET.ADDRESS}\n` + `4. 대표전화: ${FITPET.TEL}`}
        <br />
        <br />
        부 칙<br />
        제1조 (시행일) <br />이 약관은&nbsp;
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        2023년 04월 24일 부터
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        &nbsp;시행합니다.
      </TextLegacy>
      <br />
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        종전의 약관은 이 약관으로 대체됩니다.
        <br />
        종전의 약관은 하단 링크에서 확인하실 수 있습니다.
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        <br />
        <br />
        제2조 (위치정보관리책임자)
        <br />
        위치정보관리책임자는&nbsp;
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        2023년 4월 13일을
      </TextLegacy>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        &nbsp;기준으로 다음과 같이 지정합니다.
        <br />
      </TextLegacy>
      <TextLegacy size={fontSize} underline style={{ display: 'inline' }}>
        {`1. 소 속: ${FITPET.LOCATION_INFORMATION_POSITION}`} <br />
        {`2. 성 명: ${FITPET.LOCATION_INFORMATION_OFFICER}`} <br />
        {`3. 연락처: ${FITPET.LOCATION_INFORMATION_OFFICER_TEL}`}
        <br />
        <br />
      </TextLegacy>

      <LinkButtonGotoPolicyPage
        text="이전 위치기반서비스 이용약관 보기"
        url={`${ENV_CONFIG.fitpetmallHost}${ROUTES.POLICY.BEFORE_LOCATION_PRIVACY_20220125}`}
      />
    </div>
  )
}

export default PolicyLocation
